import * as React from "react";

import { Group, Image, Stack, Text, Tooltip, useMantineTheme } from "@mantine/core";
import { IconCopy, IconSettings } from "@tabler/icons-react";

import colorfulChecklistImage from "../../../data/images/updates/2024-01-20/colorful-checklist.png";
import { WhatsNewUpdate } from "../update";

const Subject = (): JSX.Element => {
  const theme = useMantineTheme();
  return (
    <Group spacing="xs" align="center">
      <Text>
        <Text
          span
          variant="gradient"
          gradient={{ from: "red", to: "orange", deg: 45 }}
          style={{
            backgroundColor: theme.colors.pink[1],
            backgroundImage: theme.fn.linearGradient(125, "green", "cyan", "pink", "orange"),
          }}
        >
          Colors
        </Text>{" "}
        <Text span fw={400}>
          and
        </Text>{" "}
        <Text span fw={700}>
          font
        </Text>{" "}
        <Text span fw={900}>
          weights
        </Text>
      </Text>
    </Group>
  );
};

export const update20240120: WhatsNewUpdate = {
  id: "1790280F-362D-47B1-99DF-72A4AE13BA80",
  date: "2024-01-20",
  subject: <Subject />,
  content: (
    <Stack>
      <Text>
        You can now customize the text and background colors of individual checklist items and
        headers, or as default styles for the entire document. This can be especially useful for
        highlighting critical items, like software that needs to be updated prior to starting the
        simulator or items you are prone to forgetting. I also think it is a neat way to color-code
        checklists for different aircraft families!
      </Text>
      <Image
        src={colorfulChecklistImage}
        fit="contain"
        placeholder="A checklist doucment with customized colors"
        radius="sm"
        imageProps={{ width: "30%" }}
        sx={(theme) => ({
          border: `1px solid ${theme.colors.gray[2]}`,
          borderRadius: theme.radius.sm,
          maskImage:
            "linear-gradient(to bottom, transparent 0, black var(--top-mask-size, 0), black calc(100% - var(--bottom-mask-size, 0)), transparent 100%);",
          "--bottom-mask-size": "96px !important",
        })}
      />
      <Text>
        You can also now adjust the font weights for individual checklist items/headers or for the
        entire document, too. To adjust individual element styles, click the{" "}
        <Tooltip label="Adjustments">
          <IconSettings size={14} />
        </Tooltip>{" "}
        icon next to the checklist element you want to modify. I also threw in the ability to
        duplicate a checklist item from the same menu (click{" "}
        <Tooltip label="Duplicate">
          <IconCopy size={14} />
        </Tooltip>
        )
      </Text>
    </Stack>
  ),
};
